import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
import TableData from "../data/table/commitee.json";
import Commitee from "../components/table/Commitee";

// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';

// const divStyle1={
//     mso-tab-count:1

// };

// const divStyle2={
//     mso-list:"Ignore"

// };

const Committees = () => {
  return (
    <React.Fragment>
      <SEO title="Committees | ICSI 2022" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2.jpg"
        title="Committees"
        content="The Conference"
        contentTwo="Committees"
        linkage="/"
      />

      {/* <HomeAbout /> */}
      <EmptyTwo>
        <div className="entry-content">
          <div className="committee">
            <p>
              <b>
                <h5>Honorary Co-chairs</h5>
              </b>
            </p>

            <p>
              <span>Zongben Xu, Xi&apos;an Jiaotong University, China</span>
            </p>

            <p>Russell C. Eberhart, IUPUI, USA</p>

            <p>
              <span>&nbsp;</span>
            </p>
            <p>
              <b>
                <h5>General Chair</h5>
              </b>
            </p>

            <p>
              <span>Ying Tan, Peking University, China</span>
            </p>


            <p>
              <span>&nbsp;</span>
            </p>

            <p>
              <b>
                <h5>Program Committee Chair</h5>
              </b>
            </p>

            <p>
              <span>
                Yuhui Shi, Southern University of Science and Technology, China
              </span>
            </p>

            <p>
              <span>&nbsp;</span>
            </p>

            <p>
              <b>
                <h5>Advisory Committee Co-chairs</h5>
              </b>
            </p>

            <p>Xingui He, Peking University, China</p>

            <p>Gary G. Yen, Oklahoma State University, USA</p>

            <p></p>

            <p>
              <span>&nbsp;</span>

              <b>
                <h5>Technical Committee Co-chairs</h5>
              </b>
            </p>

            <p>
              <span>Haibo He, University of Rhode Island Kingston, USA</span>
            </p>

            <p>
              <span>Kay Chen Tan, City University of Hong Kong, China</span>
            </p>

            <p>
              <span>
                Nikola Kasabov, Aukland University of Technology, New Zealand
              </span>
            </p>

            <p>
              <span>
                <span>
                  Ponnuthurai Nagaratnam Suganthan, Nanyang Technological
                  University, Singapore
                </span>
              </span>
            </p>

            <p>
              <span>Xiaodong Li, RMIT University, Australia</span>
            </p>

            <p>
              <span>Hideyuki Takagi, Kyushu University, Japan</span>
            </p>

            <p>
              <span>M.Middendorf, University of Leipzig, Germany</span>
            </p>

            <p>
              <span>
              Yaochu Jin, University of Surrey, UK
              </span>
            </p>

            <p>Qirong Tang, Tongji University, China</p>

            <p>Milan Tuba, Singidunum University, Serbia</p>

            <p>
              <span>&nbsp;</span>
            </p>

            <p>
              <b>
                <h5>Plenary Session Co-chairs</h5>
              </b>
            </p>

            <p>
              <span>A.Engelbrecht, University of Pretoria, South Africa </span>
            </p>

            <p>
              <span>Chaoming Luo, Mississippi State University, USA </span>
            </p>


            <p>
              <span>&nbsp;</span>
            </p>
            <p>
              <b>
                <h5>Invited Session Co-chairs </h5>
              </b>
            </p>

            <p>Andres Iglesias, University of Cantabria, Spain</p>

            <p>
              Haibin Duan, Beihang University, China<span> </span>
            </p>

            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Special Session Co-chairs</h5>
              </b>
            </p>

            <p>
              <span>Ben Niu, Shenzhen University, China </span>
            </p>

            <p>Yan Pei, University of Aizu, Japan</p>
            <p>Shaoqiu Zheng, The 28th Research Institute of China Electronics Technology Group Corporation, China</p>

            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Tutorial Co-chairs</h5>
              </b>
            </p>

            <p>Junqi Zhang, Tongji University, China</p>

            <p>
              <span>Gaige Wang, China Ocean University, China</span>
              <span> </span>
            </p>

            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Publication Co-chairs</h5>
              </b>
            </p>

            <p>
                
              <span>
              Swagatam Das, Indian Statistical Institute, India
              </span>
            </p>

            <p>
            <span>
              Radu-Emil Precup, Politehnica University of Timisoara, Romania
              </span>
            </p>

            <p>
            <span>
              Pengfei Guo, Xi&apos;an Jiaotong University Press, China 
              </span>
            </p>

            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Finance and Registration Co-chairs</h5>
              </b>
            </p>

            <p>
              <span>Andreas Janecek, University of Vienna, Austria </span>
            </p>

            <p>
              <span>
                Suicheng Gu, Google Corporation, USA
              </span>
            </p>

            <p>
              <span>&nbsp; </span>
            </p>

            <p>
              <b>
                <h5>Publicity Co-chairs</h5>
              </b>
            </p>

            <p>
              <span>
                Yew-Soon Ong, Nanyang Technological University, Singapore
              </span>
            </p>

            <p>
              <span>
                Carlos Coello, CINVESTAV-IPN, Mexico
              </span>
            </p>

            <p>
              <span>
              Mengjie Zhang, Victoria University of Wellington, New Zealand
              </span>
            </p>


            <p> <span> Dongbin Zhao, Institute of Automation, CAS, China </span></p>
            <p> <span> Rossi Kamal, GERIOT, Bangladesh</span></p>

            <span> &nbsp; </span>

            <p>
              <b>
                <h5>Local Arrangement Co-chairs </h5>
              </b>
            </p>

            <p><span> Liangjun Ke, Xi&apos;an Jiaotong University, China </span> </p>
            <p><span> Shi Cheng, Shanxi Normal University, China </span> </p>
            <p><span> Yongzhi Zhe, Xi&apos;an University of Posts and Telecommunications, China</span> </p>


            {/* <p>
              <b>
                <h5>Sponsors and Co-Sponsors</h5>
              </b>
            </p>

            <p>
              International Association of Swarm and Evolutionary Intelligences
              (IASEI)
            </p>

            <p>
              <span>Xi&apos;an Jiaotong University </span>
            </p>
            <p>
              <span>Shaanxi Normal University </span>
            </p>
            <p>
              <span>Xidian Univeresity </span>
            </p>
            <p>
              <span>Peking University </span>
            </p>

            <p>
              <span>Southern University of Science and Technology </span>
            </p>

            <p>
              <span>Beijing XingHui Hi-Tech Co. </span>
            </p>
            <p>
              <span>Nanjiing Kangbo Intelligent Health Academy </span>
            </p>

            <p></p>

            <span> &nbsp; </span>
            <p>
              <b>
                <h5>Technical Co-sponsors</h5>
              </b>
            </p>

            <p>
              <span>IEEE Computational Intelligence Society </span>
            </p>

            <p>
              <span>IEEE Beijing Chapter </span>
            </p>

            <p>
              <span>World Federation of Soft Computing </span>
            </p>

            <p>
              <span>International Society of Neural Net </span>
            </p>

            <p>
              <span>Springer</span>-Nature
            </p>

            <p>
              <span>De Gruyter Open </span>
            </p>

            <p></p> */}

            <br/>
            <br/>
            <br/>

            <p>
              <h5 align="center">International Program Committee </h5>
            </p>
          </div>
          <table cellPadding={0} cellSpacing={0}>
            <colgroup>
              <col width={200} />
              <col width={200} />
              <col width={687} />
            </colgroup>
            <tbody>
              <tr height={18}>
                <td height={18} width={150}>
                  <div align="left">
                    <strong>First Name</strong>
                  </div>
                </td>
                <td width={180}>
                  <div align="left">
                    <strong>Last Name</strong>
                  </div>
                </td>
                <td width={687}>
                  <div align="left">
                    <strong>Affiliate</strong>
                  </div>
                </td>
              </tr>
              
              {TableData &&
                TableData.map((single, key) => {
                  return <Commitee data={single} key={key} />;
                })}
              
            </tbody>
          </table>

          <p></p>

          <p></p>
        </div>
      </EmptyTwo>
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Committees;
